/* eslint-disable */
import React, { useState, useEffect } from "react";
import { Form, Field } from "react-final-form";
import { Link } from "react-router-dom";
import DatePicker from "react-datepicker";
import Header from "../../layouts/Header";
import Sidebar from "../../layouts/Sidebar";
import Select from "react-select";
import useCustomerHook from "../customers/useCustomerHook";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";

const AddExpenses = () => {
  const { customers } = useCustomerHook();
  const { id } = useParams();

  // Replace with actual customer list from API or state
  const customerOptions = React.useMemo(
    () =>
      customers?.map((customer) => ({
        value: customer.id,
        label: customer?.user?.full_name,
        data: customer,
      })) || [],
    [customers]
  );

  const onSubmit = async (values) => {
    const formData = new FormData();
    for (const field in values) {
      if (values[field] == null) {
        formData.append(field, "");
        continue;
      }
      formData.append(field, values[field]);
    }
    try {
      // Make sure file is properly handled
      if (values.date instanceof Date) {
        formData.set("date", values.date.toISOString().split("T")[0]);
      }
      if (values.file) {
        formData.append("file", values.file);
      }

      // Handle customer selection (if it's an object with value property)
      if (
        values.customer_details &&
        typeof values.customer_details === "object"
      ) {
        formData.append("customer", values.customer_details.value);
      }
      console.log("Category Name:", values);
      if (values?.category_name && typeof values.category_name === "object") {
        formData.append("category", values.category_name.value);
      }

      const response = await fetch(`/expenses/${id}/`, {
        method: "PUT",
        body: formData,
        credentials: "include",
        headers: {
          "X-CSRFToken": document.cookie  
            .split("; ")
            .find((row) => row.startsWith("csrftoken="))
            ?.split("=")[1],
        },
        // No Content-Type header needed as FormData sets it automatically
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Success:", data);
      window.location.href = "/expenses";
      // Handle success (e.g., redirect or show success message)
    } catch (error) {
      console.error("Error submitting expense:", error);
      // Handle error (e.g., show error message to user)
    }
    // API call can go here
  };

  // Expense type options (replace with your actual categories if needed)
  const [expenseTypeOptions, setExpenseTypeOptions] = useState([]);

  useEffect(() => {
    // Fetch expense types from API
    fetch("/expenses/categories/", {
      credentials: "include",
      headers: {
        "X-CSRFToken": document.cookie
          .split("; ")
          .find((row) => row.startsWith("csrftoken="))
          ?.split("=")[1],
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (Array.isArray(data)) {
          setExpenseTypeOptions(
            data.map((cat) => ({
              value: cat.id,
              label: cat.name,
            }))
          );
        }
      })
      .catch((err) => {
        console.error("Error fetching expense types:", err);
      });
  }, []);
  const [initialValues, setInitialValues] = useState({ date: new Date() });

  useEffect(() => {
    // Replace 'id' with the actual expense ID, e.g., from route params
    if (expenseTypeOptions.length > 0) {
      console.log("Fetching expense with ID:", id);
      fetch(`/expenses/${id}/`)
        .then((res) => res.json())
        .then((data) => {
          const finalData = { ...data };
          // Convert date string to Date object for DatePicker
          if (finalData.date) {
            finalData.date = new Date(finalData.date);
          }
          // Set category and customer as select option objects
          if (finalData.category) {
            const categoryOption = expenseTypeOptions.find(
              (opt) => opt.value === finalData.category_id
            );
            console.log(
              "Matched Category Option:",
              finalData,
              categoryOption,
              expenseTypeOptions
            );
            finalData.category_name = categoryOption || {
              value: finalData.category,
              label: finalData.category,
            };
            delete finalData.category;
          }
          if (finalData.customer) {
            finalData.customer_details = {
              value: finalData.customer.id,
              label: finalData.customer.user?.full_name,
              data: finalData.customer,
            };
          }
          setInitialValues(finalData);
        })
        .catch((err) => {
          console.error("Error fetching expense:", err);
        });
    }
  }, [expenseTypeOptions]);

  return (
    <>
      <div className={`main-wrapper`}>
        <Header menu />
        <Sidebar />
        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row">
                <div className="col-sm-12">
                  <h3 className="page-title">Edit Expenses</h3>
                </div>
              </div>
            </div>
            <div className="card customers">
              <div className="card-body">
                <Form
                  onSubmit={onSubmit}
                  initialValues={
                    initialValues ? initialValues : { date: new Date() }
                  }
                  render={({ handleSubmit, values, form }) => (
                    <form onSubmit={handleSubmit}>
                      <div className="row">
                        <div className="col-md-12 mb-3">
                          <label>
                            Expense Name: <span className="text-danger">*</span>
                          </label>
                          <Field
                            name="name"
                            component="input"
                            type="text"
                            className="form-control"
                            required
                          />
                        </div>
                        <div className="col-md-12 mb-3">
                          <label>
                            Date: <span className="text-danger">*</span>
                          </label>
                          <Field name="date">
                            {({ input }) => (
                              <DatePicker
                                className="datetimepicker form-control"
                                selected={input.value}
                                onChange={input.onChange}
                                dateFormat="dd/MM/yyyy"
                                disabledPast
                                placeholderText="Select date"
                                required
                              />
                            )}
                          </Field>
                        </div>
                        <div className="col-md-12 mb-3">
                          <label>
                            Expense Type: <span className="text-danger">*</span>
                          </label>
                          <Field name="category_name">
                            {({ input }) => (
                              <Select
                                {...input}
                                onChange={input.onChange}
                                options={expenseTypeOptions}
                                placeholder="Select Expense Type"
                                required
                              />
                            )}
                          </Field>
                        </div>

                        <div className="col-md-12 mb-3">
                          <label>
                            Amount: <span className="text-danger">*</span>
                          </label>
                          <Field
                            name="amount"
                            component="input"
                            type="number"
                            className="form-control"
                            required
                          />
                        </div>

                        <div className="col-md-12 mb-3">
                          <label>Invoice Number:</label>
                          <Field
                            name="invoice_number"
                            component="input"
                            type="text"
                            className="form-control"
                          />
                        </div>

                        <div className="col-md-12 mb-3">
                          <label>Notes:</label>
                          <Field
                            name="notes"
                            component="textarea"
                            rows={2}
                            className="form-control"
                          />
                        </div>

                        <div className="col-md-12 mb-3">
                          <label>File:</label>
                          {initialValues?.file && !values.fileRemoved ? (
                            <div className="mb-2">
                              <a
                                href={initialValues.file}
                                download
                                target="_blank"
                                rel="noopener noreferrer"
                                className="btn btn-outline-primary btn-sm me-2"
                              >
                                Download File
                              </a>
                              <button
                                type="button"
                                className="btn btn-outline-danger btn-sm"
                                onClick={() => {
                                  form.change("fileRemoved", true);
                                  form.change("file", null);
                                }}
                              >
                                Remove File
                              </button>
                            </div>
                          ) : (
                            <Field name="file">
                              {({ input }) => (
                                <input
                                  type="file"
                                  className="form-control"
                                  onChange={(e) =>
                                    input.onChange(e.target.files[0])
                                  }
                                />
                              )}
                            </Field>
                          )}
                          <small className="text-muted">
                            Upload receipt or supporting documentation
                          </small>
                        </div>
                        <div className="col-md-12 mb-3">
                          <label>Customer:</label>
                          <Field name="customer_details">
                            {({ input }) => (
                              <Select
                                {...input}
                                onChange={input.onChange}
                                options={customerOptions}
                                placeholder="Select Customer"
                              />
                            )}
                          </Field>
                        </div>
                        <div className="col-md-12 mb-3">
                          <label>Supplier </label>
                          <Field
                            name="supplier"
                            component="input"
                            type="text"
                            className="form-control"
                          />
                        </div>

                        <div className="col-md-12 text-end mt-4">
                          <button type="submit" className="btn btn-primary">
                            Edit Expenses
                          </button>
                        </div>
                      </div>
                    </form>
                  )}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddExpenses;
